import type { Maybe } from '@adornis/base/utilTypes.js';
import { Float } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';

/**
 * Cache for geocoded ticket addresses. Keyed by `ticketNumber`. Avoids re-geocoding
 * the same address on every page load, and gives the customer/admin map a destination
 * even when ServiceNow's ticket_details endpoint doesn't expose lat/lng directly.
 *
 * If the address text changes, the cache is invalidated (we keyed on ticket but also
 * compare `addressLabel` and re-geocode on mismatch).
 */
@Entity()
export class TicketLocationCache extends MongoEntity {
  static override _class = 'TicketLocationCache';
  static override _collectionName = 'smartteams_ticket_location_cache';

  @Field(() => String)
  ticketNumber: Maybe<string>;

  @Field(() => String)
  addressLabel: Maybe<string>;

  @Field(() => Float)
  lat: Maybe<number>;

  @Field(() => Float)
  lng: Maybe<number>;

  @Field(() => Date, { default: v => v ?? new Date() })
  geocodedAt: Maybe<Date>;
}
